import React from 'react';
import styled from 'styled-components';
import dt from '../../shared/theme';

const Hr = styled.hr`
  margin: 20px 0;
  ${props => (dt(props).theme.isMobile ? `
    width: 100%;
    border: none;
    border-bottom: 1px solid #d7dfe7;
  ` : `
    width: 148px;
    border: 0.02em solid ${dt(props).theme.primaryColor};
  `)};
`;

export default function EndOfWire() {
  return <Hr />;
}
